
class PillSelectController

    ### @ngInject ###
    constructor: ($element, $scope, Page) ->
        
        @ngModel = $element.controller('ngModel')
        @ngModel.$render = @render
        @mobile = Page.isMobile()
        $scope.$on 'resize', => @mobile = Page.isMobile()

    render: =>
        @selected = @ngModel.$viewValue
        return

    select: (option) ->
        @ngModel.$setViewValue(option)
        @render()
        return


pillSelectDirective = ->
    restrict: 'E'
    templateUrl: 'util/widgets/pillSelect'
    scope: options: '=', counts: '='
    require: 'ngModel'
    controller: PillSelectController
    controllerAs: 'ctrl'
    bindToController: true

module.directive 'pillSelect', pillSelectDirective
